import axios from 'axios'

export function reportRequestId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

// Cancellation also guards responses already delivered when the user changes scope.
export async function runUniversityReportExport({ base, headers, request, onStatus, isCurrent, cancelToken, maxWaitMs = 480000 }) {
  const endpoint = `${base.replace(/\/+$/, '')}/reports/university`
  const deadline = Date.now() + maxWaitMs
  const config = { headers, cancelToken, timeout: 20000 }
  if (!isCurrent()) return null
  let status
  if (!request.jobId) {
    let response
    try {
      response = await axios.post(endpoint, { ...request.payload, requestId: request.id }, config)
    } catch (error) {
      if (error.response && [409, 410].includes(error.response.status)) error.restartExport = true
      throw error
    }
    if (!isCurrent()) return null
    status = response.data || {}
    if (!status.job_id) throw new Error('Report did not return a job ID. Please retry.')
    request.jobId = status.job_id
  }
  let failures = 0
  while (Date.now() < deadline && isCurrent()) {
    if (status) {
      if (status.status === 'failed') {
        const error = new Error(status.message || 'PDF generation failed or timed out. Please retry.')
        error.restartExport = true
        throw error
      }
      if (status.status === 'completed' && status.download_url) {
        onStatus('completed')
        return status
      }
      if (!['queued', 'running', 'completed'].includes(status.status)) throw new Error('Unexpected report status. Please retry.')
      onStatus(status.status === 'completed' ? 'running' : status.status)
      if (status.status !== 'completed') {
        await new Promise(resolve => {
          const timer = setTimeout(resolve, Math.min(5, Math.max(1, Number(status.poll_after_seconds) || 2)) * 1000)
          cancelToken.promise.then(() => { clearTimeout(timer); resolve() })
        })
      }
    }
    if (!isCurrent()) return null
    try {
      const response = await axios.get(`${endpoint}/jobs/${encodeURIComponent(request.jobId)}`, config)
      if (!isCurrent()) return null
      status = response.data || {}
      // A completed status without a download is a service error, not an endless poll.
      if (status.status === 'completed' && !status.download_url) throw new Error('PDF download is unavailable. Please retry.')
      failures = 0
    } catch (error) {
      if (!isCurrent() || axios.isCancel(error)) return null
      const code = error.response && error.response.status
      if (code === 410 || code === 404) error.restartExport = true
      if ((code && code < 500) || ++failures > 3) throw error
      status = { status: 'running', poll_after_seconds: Math.min(5, failures * 2) }
    }
  }
  if (!isCurrent()) return null
  throw new Error('The report is taking longer than expected. Select Retry PDF to check this export again.')
}
